export const valid_sources_for_challenges = [
    'cms_admin'
];

export const backend_responses = {
    1: 'OK',
    2: 'NO_DATA',
    3: 'ERROR',
};

export const CONFETTI_SETUP = {
    angle: 90,
    spread: '253',
    startVelocity: 40,
    elementCount: '200',
    dragFriction: '0.11',
    duration: 3000,
    stagger: 3,
    width: '7px',
    height: '9px',
    perspective: '500px',
    colors: ['#a864fd', '#29cdff', '#78ff44', '#ff718d', '#fdff6a'],
}

export const DEFAULT_AVATAR = () => {
    return {
      active: true,
      avatarFormat: 'GIF',
      avatarPack: null,
      creationDate: null,
      id: 1,
      name: 'Avatar+1',
      ordinalAvatarFormat: 1,
      value: 'Avatar-1.gif',
    }
}
